/*
 *  Copyright (c) Qwoach LLC 2021. All rights reserved.
 *  Unauthorized copying of this file, via any medium is strictly prohibited
 *  Proprietary and confidential
 *  Created by Artem Bogush <artem@qwoach.com> on 10/12/2021
 */

import {ClearanceLevelEnum} from "@shared/Profile/ClearanceLevelEnum.js";
import FilterableItem from "@shared/Filterable/FilterableItem.js";
import dayjs from "dayjs";
import {AgeDateDisplayEnum} from "@shared/Genogram/AgeDateDisplayEnum";

export default class GenogramItem extends FilterableItem {

	jsonData: Object = {}
	clientId: string = null
	ageDateDisplay: AgeDateDisplayEnum = AgeDateDisplayEnum.FULL

	clearanceLevel: ClearanceLevelEnum = ClearanceLevelEnum.PHI;


	constructor(clientId: string = null) {
		super();
		this.clientId = clientId;
	}

	getCurrentSchemaVersion(){
		return 2
	}

	migrateSchema(oldVersion, newVersion) {
		if(oldVersion < 2) {
			this.ageDateDisplay = AgeDateDisplayEnum.FULL
		}
		super.migrateSchema(oldVersion, newVersion);
	}

	iterateNodes(callback){
		let nodesArray = this.jsonData.elements?.nodes || []
		for(let node of nodesArray){
			callback(node.data)
		}
	}

	updateNodeLabelAll() {
		this.iterateNodes((nodeData) => {
			this.updateNodeLabel(nodeData)
		})
	}

	updateNodeLabel(nodeData) {
		let age = null
		let dateOfBirth = null
		let dateOfDeath = null
		if (nodeData.dateOfBirth) {
			let rightDate = dayjs()
			if (nodeData.isPassedAway && nodeData.dateOfDeath) {
				rightDate = dayjs(nodeData.dateOfDeath)
			}
			age = rightDate.diff(dayjs(nodeData.dateOfBirth), 'year')
		}
		if (nodeData.dateOfBirth) {
			dateOfBirth = "Born: " + dayjs(nodeData.dateOfBirth).format(nodeData.birthFormat || "MMM DD, YYYY")
		}
		if (nodeData.isPassedAway && nodeData.dateOfDeath) {
			let text = ""
			if(nodeData.dateOfBirth && age && age <= 0){
				text = "Stillbirth or miscarriage: "
			} else {
				text = "Passed away: "
			}
			dateOfDeath = text + dayjs(nodeData.dateOfDeath).format(nodeData.deathFormat || "MMM DD, YYYY")
		}
		if(age !== null){
			if (age === 0) {
				age = 'Infant'
			} else {
				age = age + " y.o."
			}
		}
		switch (this.ageDateDisplay) {
			case AgeDateDisplayEnum.AGE_ONLY:
				dateOfBirth = null
				break
			case AgeDateDisplayEnum.DATE_ONLY:
				age = null
				break
			case AgeDateDisplayEnum.FULL:
				break
		}
		let notePublic = nodeData.notePublic ? "\n" + nodeData.notePublic : null
		let textLine = [nodeData.relationship, nodeData.gender, age].filter(item => !!item).join(", ")
		nodeData.label = [nodeData.name, textLine, dateOfBirth, dateOfDeath, notePublic].filter(item => !!item).join(",\n")
	}
}
